import { createFileRoute } from '@tanstack/react-router';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';
import { WebsitesSettingsPage } from 'src/modules/websites/components/pages/websites-settings.page';

export const Route = createFileRoute('/settings/websites')({
  component: WebsitesSettingsPage,
  validateSearch: (search) => settingsSearchSchema.parse(search),
});
